// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"a8b4ac32","488":"216bea7c","692":"1c03a24c"}[chunkId] + ".chunk.js";
};